import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router-dom';

import { Row, Grid, Col } from '../GridSystem';
import Logo from '../../assets/logo.svg';

class Header extends Component {
    renderMenu() {
        const menus = [
            {
                key: 'works',
                label: 'Works',
            },
            {
                key: 'about',
                label: 'About',
            },
            {
                key: 'blog',
                label: 'blog',
            },
            {
                key: 'start-a-project',
                label: 'Start a Project',
                className: 'special-link',
            },
        ];
        const { location } = this.props;

        return menus.map((menu, index) => {
            let active = location.pathname === `/${menu.key}` ? 'active' : 'inactive';

            // If on homepage, all link is active
            if (location.pathname === '/') {
                active = 'active';
            }

            let itemClass = menu.className ? menu.className : '';
            itemClass += ` ${active}`;

            return (
                <li key={index} className={itemClass}>
                    <Link to={`/${menu.key}`}>
                        {menu.label}
                    </Link>
                </li>
            );
        });
    }

    render() {        
        return (
            <div className="sticky-bar">
                <div className="sticky-bar__inner">
                    <div className="topbar-section">
                        <Grid className="wrapper--full">
                            <Row className="grid--middle">

                                <Col xs={9} md={9} lg={3} className="logo-grid">
                                    <Link to="/" className="logo-block" title="Design with Heart">
                                        <img src={Logo} alt="Hubton Indonesia" className="logo-block__img" />
                                    </Link>
                                </Col>

                                <Col xs={3} md={3} className="mobile-button-grid text-align-right large--hide">
                                    <button className="menu-trigger">
                                        <span className="menu-trigger__bar"></span>
                                        <span className="menu-trigger__bar"></span>
                                        <span className="menu-trigger__bar"></span>
                                    </button>
                                </Col>

                                <Col lg={9} className="menu-grid">
                                    <nav className="main-nav">
                                        <ul>
                                            {this.renderMenu()}
                                        </ul>
                                    </nav>
                                </Col>

                            </Row>
                        </Grid>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(Header);


// WEBPACK FOOTER //
// ./src/components/Header/index.js